var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-4",attrs:{"rounded":""}},[_c('p',{staticClass:"text-h4"},[_vm._v("Página no encontrada")]),_c('p'),_c('p',[_vm._v("La página requerida no existe")]),_c('v-btn',{on:{"click":_vm.irPaginaInicio}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" home ")]),_vm._v(" Ir a página principal ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }